import { OfferingOptionValueModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class OfferingOptionValueService extends ApiService<OfferingOptionValueModel> {
        constructor() {
                super('offeringoptionvalue');
        }

        async getByOption(optionId: string | number): Promise<OfferingOptionValueModel[]> {
                const params = new URLSearchParams({ 
                        where: JSON.stringify({ offeringoptionid: Number(optionId) }),
                        limit: '0' 
                });
                return this.getAll(params);
        }

        async getByIds(ids: number[]): Promise<OfferingOptionValueModel[]> {
                if (ids.length === 0) return [];
                const params = new URLSearchParams({ 
                        where: JSON.stringify({ id: ids }),
                        limit: '0' 
                });
                return this.getAll(params);
        }
}

export default new OfferingOptionValueService();
